import { firestore } from './../firebase-config';
import { id_firebase } from '../content-site';

export async function fetchRevenda(id_firebase, setState) {
    if (!id_firebase) {
        console.warn("ID da revenda não fornecido!");
        return;
    }

    try {
        const docRef = firestore.collection("revenda").doc(id_firebase);
        const doc = await docRef.get();

        if (doc.exists) {
            setState((prevState) => ({
                ...prevState,
                revenda: doc.data()
            }));
        } else {
            console.warn("Nenhuma revenda encontrada!");
            setState({ revenda: { ativo: 0 } });
        }
    } catch (error) {
        console.error("Erro ao buscar revenda:", error);

    }
}


export function subscribeToCollection(collectionName, options, setState, unsubscribeList = []) {
    if (!Array.isArray(unsubscribeList)) {
        console.error("Erro: unsubscribeList não é um array válido.", unsubscribeList);
        return;
    }

    let query = firestore.collection("revenda").doc(id_firebase).collection(collectionName);

    if (options.filters) {
        options.filters.forEach(([field, op, value]) => {
            query = query.where(field, op, value);
        });
    }

    if (options.orderBy) {
        query = query.orderBy(options.orderBy, "desc");
    }

    const unsubscribe = query.onSnapshot((querySnapshot) => {
        const items = querySnapshot.docs
            .map((doc) => ({ id: doc.id, ...doc.data() }))
            .map(options.processDoc || ((doc) => doc))
            .filter(Boolean);

        setState({ [options.stateKey]: items });
    });

    unsubscribeList.push(unsubscribe);
}

export async function fetchVeiculo(idVeiculo, setState) {
    if (!idVeiculo) {
        console.error("Erro: ID não encontrado");
        return;
    }

    try {
        const doc = await firestore.collection("revenda").doc(id_firebase).collection("veiculos").doc(idVeiculo).get();
        if (doc.exists) {
            setState({ veiculo: doc.data() })
        } else {
            console.warn("Veículo nao encontrado:", idVeiculo)
            setState({ veiculo: null })
        }
    } catch (error) {
        console.error("Erro ao buscar veículo:", error)
    }
}